<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Support Request</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/ticketsystems/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/TicketSystems/MenuList.vue";
    import lang from "@/views/modules/TicketSystems/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomSearch from "@/views/modules/TicketSystems/SearchView.vue";

    export default {
        name: "new-ticket",
        components: {
            breadcrumbs,
            GenericList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_TICKET_NUMBER,
                        link: true,
                        moduleName: 'TicketSystems',
                        routePath: 'ticketsystems',
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'ticket_no'

                    },
                    {
                        label: lang.LBL_REQUEST_TO,
                        link: false,
                        moduleName: 'TicketSystems',
                        routePath: 'ticketsystems',
                        linkOtherModule: false,
                        isSort: true,
                        relRef:'ticketsystems_assigned_users',
                        field_name: 'name__assigned'

                    },
                    {
                        label: lang.LBL_REQUEST_BY,
                        link: false,
                        moduleName: 'TicketSystems',
                        routePath: 'ticketsystems',
                        linkOtherModule: false,
                        isSort: true,
                        relRef:'ticketsystems_users',
                        field_name: 'name'

                    },
                    {
                        label: lang.LBL_TICKET_TYPE,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'ticket_type'
                    },
                    /* {
                        label: lang.LBL_ED_SUPPORT_REQUEST,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'ed_support'
                    }, */
                    {
                        label: lang.LBL_DESCRIPTION,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'description'
                    },
                    {
                        label: lang.LBL_TICKET_STATUS,
                        link: false,
                        linkOtherModule: false,
                        isSort: true,
                        field_name: 'status'
                    },
                ],
                columns: ['ticket_no', 'assigned_user', 'created_by_name', 'ticket_type', 'description', 'status'],
            }
        },
        mounted() {
            this.childMethod();
            this.$emit('MetaView', 'Awesome')
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getProducts(search);
                    }
                }
            },

            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>